import { combineReducers } from 'redux';
import userReducer from './user.reducer';
import generalReducer from './general.reducer';
import geolocationReducer from './geolocation.reducer';
import boxofficeReducer from './boxoffice.reducer';
import moviesReducer from './movies.reducer';
import commentsReducer from './comments.reducer';
import movieTheatersReducer from './movietheater.reducer';
import newsReducer from './news.reducer';
import tagsReducer from './tags.reducer';
import searchResultsReducer from './searchresults.reducer';
import filtersReducer from './filters.reducer';
import scheduleReducer from './schedule.reducer';
import profileReducer from './profile.reducer';
import loadingReducer from './loading.reducer';
import festivalReducer from './festival.reducer';
import editProfileReducer from './editProfile.reducer';
import paymentReducer from './payment.reducer';
import pagesReducer from './pages.reducer';

import { reducer as FormReducer } from 'redux-form'


export default combineReducers({
    user: userReducer,
    form: FormReducer,
    errors: generalReducer,
    geolocation: geolocationReducer,
    boxoffice: boxofficeReducer,
    movies: moviesReducer,
    comments: commentsReducer,
    movieTheaters: movieTheatersReducer,
    news: newsReducer,
    tags: tagsReducer,
    searchResults: searchResultsReducer,
    filters: filtersReducer,
    schedule: scheduleReducer,
    profile: profileReducer,
    loading: loadingReducer,
    festival: festivalReducer,
    editProfile: editProfileReducer,
    payment: paymentReducer,
    pages: pagesReducer
});



// WEBPACK FOOTER //
// ./src/SHARED/reducers/index.js